import React from 'react';
import { isFunction } from 'lodash';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 */
export const endScrollDetector = ( props ) => {

	// check if render-prop is provided
	if( isFunction( props.render ) ) {
		return props.render( {
			ref: props.viewRef
		} );
	}

    return React.cloneElement( props.children, {
		ref: props.viewRef
	} );
};

// set display name
endScrollDetector.displayName = 'endScrollDetector';

// set default props
endScrollDetector.defaultProps = {};

// prop types
endScrollDetector.propTypes = {};
